"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepNumberMobile = exports.StepNumberDesktop = void 0;
var _react = _interopRequireDefault(require("react"));
var _decorators = require("../../decorators");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//styled-components

var StepNumberDesktop = exports.StepNumberDesktop = (0, _decorators.styleable)(function (_ref) {
  var number = _ref.number;
  return /*#__PURE__*/_react["default"].createElement(_styles.StepNumber, {
    className: "stepNumber",
    device: "desktop",
    "data-cy": "step-number"
  }, number);
});
var StepNumberMobile = exports.StepNumberMobile = (0, _decorators.styleable)(function (_ref2) {
  var number = _ref2.number;
  return /*#__PURE__*/_react["default"].createElement(_styles.StepNumber, {
    className: "stepNumber",
    device: "mobile",
    "data-cy": "step-number"
  }, number);
});
//# sourceMappingURL=index.js.map